export * from './responsive-class-names'

export const overflowEllipsis = `
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`

export type ObjectFit =
    | 'cover'
    | 'contain'
    | 'fill'
    | 'initial'
    | 'none'
    | 'scale-down'
